//splide
const homeSlide = document.getElementById('homeSlide');
const slides = homeSlide.querySelectorAll('.splide__slide');
const slideCount = slides.length;
let homeSplide = new Splide(homeSlide, {
  type: 'loop',
  perPage: 3,
  autoplay: true,
  interval: 3500,
  speed: 500,
  easing: 'cubic-bezier(0,1,.75,1.1)',
  gap: '24px',
  focus: 'center',
  pagination: false,
  arrow: slideCount > 3 ? true : false,
  destroy: slideCount > 3 ? false : true,
  breakpoints: {
    840: {
      arrow: slideCount > 1 ? true : false,
      destroy: slideCount > 1 ? false : true,
      perPage: 2,
      focus: 0,
    },
    640: {
      perPage: 1,
      arrows: false,
      pagination: true,
    },
  },
});

homeSplide.mount();
